export default __webpack_public_path__ + "static/media/Letters3_16.871d440b.png";